export var EVENT_CHANNEL = 'media';
export var GOAL_FORM = 'goalForm';